<template>
 
  <genelarama apiname="GenelTanitimAra" :label="getLabel" :tip="tipToInt" v-model="Model"></genelarama>

</template>

<script>

import genelarama from '@/components/app/coper/comp/genelarama.vue'

export default {
    props:["value","tip"],
    components: {
      genelarama,
    },  
      
    computed: {
      Model: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue )
        },
      },
      getLabel:{
         get : function(){
           var r = this.tip
          if (this.tip=="Bolge"){r ="Bölge"}
          if (this.tip=="Bolum"){r = "Bölüm"}
          if (this.tip=="Yonetim"){r = "Yönetim"}
          if (this.tip=="Departman"){r = "Departman"}
          if (this.tip=="AltDepartman"){r = "Alt Departman"}
          if (this.tip=="VizeFiyatTipi"){r = "Vize Fiyat Tipi"}
          if (this.tip=="AcenteDepartman"){r = "Acente Departman"}
          if (this.tip=="SebepKod"){r = "Sebep Kodu"}
          if (this.tip=="OtelFiyatKod"){r = "Otel Fiyat Kod"}
          if (this.tip=="CariTransferKod"){r = "Transfer Kod"}
          if (this.tip=="CariTevkifatKod"){r = "Tevkifat Kod"}
          if (this.tip=="CariKdvKod"){r = "Kdv Kod"}
          if (this.tip=="CariKdvIstisnaKod"){r = "Kdv Istisna Kod"}
          if (this.tip=="CariInternetSatisWebAdresi"){r = "Internet Satis Web Adresi"}
          if (this.tip=="CariInternetSatisDigerAciklama"){r = "Internet Satis Diger Aciklama"}
          if (this.tip=="CariInternetSatisOdemeAracisi"){r = "Internet Satis Odeme Aracisi"}

           return r
         }
      },

      tipToInt : function(){
        var r=-1
        if (this.tip=="Bolge"){r = 0}
        if (this.tip=="Bolum"){r = 1}
        if (this.tip=="Yonetim"){r = 2}
        if (this.tip=="Departman"){r = 3}
        if (this.tip=="AltDepartman"){r = 4}
        if (this.tip=="VizeFiyatTipi"){r = 5}
        if (this.tip=="AcenteDepartman"){r = 6}
        if (this.tip=="SebepKod"){r = 7}
        if (this.tip=="OtelFiyatKod"){r = 8}
        if (this.tip=="CariTransferKod"){r = 301}
        if (this.tip=="CariTevkifatKod"){r = 302}
        if (this.tip=="CariKdvKod"){r = 303}
        if (this.tip=="CariKdvIstisnaKod"){r = 304}
        if (this.tip=="CariInternetSatisWebAdresi"){r = 305}
        if (this.tip=="CariInternetSatisDigerAciklama"){r = 306}
        if (this.tip=="CariInternetSatisOdemeAracisi"){r = 307}
        return r;
    },

    },
  
    
    data () {
      return {
        
      }
  },
 
}


</script>